import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper from '../CardStateHelper';
import { CardModifierType } from '../../../Prototype/Level/Card/CardModifierType';
import { CardTask } from '../CardTasks';
import { SCORE_ROCK_CARD } from '../../../Constants/Score';
import { ICardsState } from '../ICardState';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import { CardState } from 'Prototype/Level/Card/CardState';

export default class RockCardBehavior extends BaseCardBehavior {
    public static getPickaxeCardIds(state: ICardsState): string[] {
        return state.inPlay.filter(cardID =>
            state.cards[cardID].modifiers.some(
                modifier => modifier.type === CardModifierType.pickaxe,
            ),
        );
    }

    public update(state: ICardsState) {
        const pickaxeCardIds = RockCardBehavior.getPickaxeCardIds(state);

        if (pickaxeCardIds.length !== 0) {
            state = CardStateHelper.setStateTaskData(state, {
                task: CardTask.ROCK_UPDATE,
                cards: [this.cardID],
                pickaxesAmount: pickaxeCardIds.length,
            });
        }

        // If there are no pickaxe modifiers left in-play then this card is discarded.
        if (
            pickaxeCardIds.length === 0 &&
            CardStateHelper.getCardState(state, this.cardID) ===
                CardState.IN_PLAY
        ) {
            state = CardStateHelper.addTurnScore(state, SCORE_ROCK_CARD);

            if (!state.tasks.find(task => task.task === CardTask.ROCK)) {
                const cardsIDs: string[] = [];
                const cardsScores: number[] = [];

                state.inPlay.forEach((cardID: string) => {
                    if (state.cards[cardID].type === CardType.rock) {
                        cardsIDs.push(cardID);
                        cardsScores.push(SCORE_ROCK_CARD);
                    }
                });

                state = CardStateHelper.setStateTaskData(state, {
                    task: CardTask.ROCK,
                    cards: cardsIDs,
                    cardsScore: cardsScores,
                });
            }

            // Clear the undo history when the rock is discarded.
            state = CardStateHelper.clearUndoHistory(state);
        }

        return state;
    }

    public isPlayable(): boolean {
        return false;
    }
}
